import React, { useState } from 'react';
import ViaIframe from './viaIframe';
import Login from './Login';
import users from './data/users.json';

export default function App() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [user, setUser] = useState(() => {
    try {
      return users.find(candidate => ['username', 'password', 'pasword_keycloak'].every(key => localStorage.getItem(key) === candidate[key])) || null;
    } catch { return null; }
  });

  if (!user) return <Login onLogin={setUser} />;

  return (
    <div className="web-shell" onKeyDown={event => { if (event.key === 'Escape') setMenuOpen(false); }}>
      <header className="web-header">
        <button className="menu-toggle" aria-label={menuOpen ? 'Tutup menu' : 'Buka menu'} aria-expanded={menuOpen} aria-controls="service-sidebar" onClick={() => setMenuOpen(!menuOpen)}>
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true"><path d={menuOpen ? 'M6 6l12 12M18 6L6 18' : 'M3 6h18M3 12h18M3 18h18'} /></svg>
        </button>
        <h1>POC CIMB</h1>
        <div className="web-account">
          <span>{user.username}</span>
          <button onClick={() => {
            ['username', 'password', 'pasword_keycloak'].forEach(key => localStorage.removeItem(key));
            setUser(null);
            setMenuOpen(false);
          }}>Keluar</button>
        </div>
      </header>
      <ViaIframe user={user} menuOpen={menuOpen} onCloseMenu={() => setMenuOpen(false)} />
    </div>
  );
}
